import {LitElement, html, css} from 'lit';
import {msg} from '@lit/localize';
import {state} from 'lit/decorators/state.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {baseProfileOptions} from '../../lightProfileSectionConfig';


@customElement('visual-lightprofile-base')
export class VisualLightprofileBase extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		width: 100%;

	  }
	  .container {
		display: flex;
		gap: 10px;
		flex-direction: row;
		align-items: end;
		height: 100%;
		width: 100%;
	  }

	  .baseProfile {
		display: block;
		width: 100vw;
		position: absolute;
		height: 100vh;
	  }

	  video {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: bottom center;
	  }

	  .overlay {
		background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 10.56%, rgba(0, 0, 0, 0) 23.43%), linear-gradient(90deg, rgba(0, 0, 0, 0.6) 22.75%, rgba(0, 0, 0, 0) 100%);
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
		margin: 0;
		box-sizing: border-box;
		pointer-events: none;
	  }

	  .baseInfo {
		position: absolute;
		bottom: var(--large-padding);
		left: var(--large-padding);
		right: var(--large-padding);
		  z-index: 10;
	}
	  .title {
		font: var(--font-small-title);
		color: var(--color-white);
		margin-bottom: 0;
		border-bottom: 1px solid white;
		padding-bottom: 20px;
	  }
	  .info {
		color: var(--color-white);
		font: var(--font-info-light);
		line-height: 30px;
		height: 100px;
		width: 70%;
	  }
	  .moreInfo {
		color: var(--color-white);
		font: var(--font-summary-table);
		line-height: 30px;
		padding: 10px 15px;
		text-decoration: none;
		border: 1px solid var(--color-white);
		float: right;
		position: absolute;
		right: 0px;
		top: 140px;
	}
	.baseProfileImage {
		position: absolute;
		bottom: 0;
		top: 20%;
		right: 0;
		width: 100%;
		height: 100%;
		right: 0px;
		top: -80px;
		object-fit: none;
		object-position: right center;
		pointer-events: none;
	  }

	@media (max-width: 768px) {
		.overlay {
			background-image: linear-gradient(rgba(0, 0, 0, 0.3) 10.56%, rgba(0, 0, 0, 0) 23.43%), linear-gradient(90deg, rgba(0, 0, 0, 0.2) 22.75%, rgba(0, 0, 0, 0) 100%), linear-gradient(0deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 36%)
			pointer-events: none;
		}
		.baseInfo {
			left: 16px;
			right: 16px;
		}
		.baseInfo.empty {
			bottom: 120px;
		}
		.info {
			font: var(--font-summary-paragraph);
			width: 100%;
			line-height: 25px;
		}
		.title {
			font: var(--font-mobile-title);
		}
		.moreInfo {
			position: initial;
			float: left;
			margin-bottom: var(--large-padding);
		}
		.baseProfileImage {
		display: none;
		}
	 }
	`;

	@state({type: String})
	_video = '';

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(s) {
		this.state = s;
		this.lang = s.status.lang;
		this.region = s.status.region;
		this.lightProfile = s.lightProfile.data;
		this.base = baseProfileOptions.find(base => base.id === this.lightProfile.project.base);
		if (this.base && this.base.video !== this._video) {
			this._video = this.base.video;
			// load video element when updated
			this.shadowRoot.querySelector('video').load();
		}
	}

	render() {
		const s = this.state;
		return html`
			<div class="container">
				<div class="baseProfile">
					${when(this.base,
							() => html`

								<video autoplay muted loop class="lightProfileVideo">
									<source src="${this._video}" type="video/mp4">
								</video>
								<div class="overlay"></div>
								<img class="baseProfileImage" src="${this.base.image}"/>
								<div class="baseInfo">
									<h1 class="title">${this.base.label[this.lang]}</h1>
									<p class="info">${this.base.description[this.lang]}</p>
									<a title="more-info" target="_blank" href="https://www.selux.com/${this.region}/${this.lang}/${this.base.link[this.lang]}" class="moreInfo">${msg('More information')}</a>
								</div>
							`,
							() => html`
                                <video autoplay muted loop class="defaultVideo" poster="">
                                    <source src="/line-assets/video/KonfigStart_fast.mp4" type="video/mp4">
                                </video>
								<div class="overlay"></div>
								<div class="baseInfo empty">
									<h1 class="title">${msg('Your Lightprofile:')}</h1>
								</div>

                            `
					)}
				</div>
			</div>
		`;
	}
}
